<template>
  <div>
    <grid-row>
      <grid-col col-size="1">
        <btn-pill
          btn-size="s"
          @click="generateReport()">
          <font-awesome-icon :icon="icon.file"/>
          {{ $t('health.nutritionalPlan.exportPdf') }}
        </btn-pill>
      </grid-col>
    </grid-row>
    <div v-for="(mealType, index) in mealTypes" :key="index">
      <div v-if="getMealsByType(mealType).length > 0">
        <h2 class="margin-left-m margin-top-m">{{ $t('health.nutritionalPlan.mealTypes')[index] }}</h2>
        <meal-cards-group
          :color="false"
          :meals="getMealsByType(mealType)"
          class="margin-top-m"
        />
      </div>
    </div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Glucovibes-Nutritional plan"
      :pdf-quality="2"
      :manual-pagination="false"
      margin="20"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1115px"
      ref="html2Pdf"
    >
      <section slot="pdf-content">

        <div v-for="(mealType, index) in getFilteredMealTypes" :key="index">
          <div v-if="getMealPage(mealType) === 0">
            <div v-if="index > 0 && getMealPage(getFilteredMealTypes[index - 1]) === 0" class="html2pdf__page-break"/>
            <section class="pdf-item">

              <img src="../../assets/Logo_login.png" class="right margin-top-l"/>
              <h2 class="margin-left-m margin-top-s">
                {{ $t('health.nutritionalPlan.mealTypes')[getMealTypeIndexByName(index)] }}</h2>
              <meal-cards-group
                :color="false"
                :meals="getMealsByType(mealType)"
                class="margin-top-m"
              />
              <div
                v-if="getFilteredMealTypes.length > (index + 1) && getMealPage(getFilteredMealTypes[index + 1]) === 1">
                <h2 class="margin-left-m margin-top-s">
                  {{ $t('health.nutritionalPlan.mealTypes')[getMealTypeIndexByName(index + 1)] }}</h2>
                <meal-cards-group
                  :color="false"
                  :meals="getMealsByType(mealType)"
                  class="margin-top-m"
                />
              </div>
            </section>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>

</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faFileDownload} from '@fortawesome/pro-solid-svg-icons';
import BtnPill from '@/components/shared/buttons/BtnPill';
import VueHtml2pdf from 'vue-html2pdf';
import MealCardsGroup from 'BRAND/components/nutritionPlan/MealCardsGroup';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import MealTypeDetails from 'BRAND/components/nutritionPlan/MealTypeDetails';

export default {
  name: 'FreeModePlan',
  components: {
    BtnPill,
    VueHtml2pdf,
    FontAwesomeIcon,
    MealCardsGroup,
    GridRow,
    GridCol,
    MealTypeDetails
  },
  props: {
    mealTypes: {
      default: []
    },
    meals: {
      default: []
    }
  },
  data: () => {
    return {
      icon: {
        file: faFileDownload
      },
      pageIndex: 0
    };
  },
  watch: {
    mealTypes: {
      handler: function () {
        this.$refs.html2Pdf.$forceUpdate();
      }
    }
  },
  computed: {
    getFilteredMealTypes () {
      return this.mealTypes.filter(type => this.getMealsByType(type).length > 0);
    }
  },
  methods: {
    generateReport () {
      this.$refs.html2Pdf.generatePdf();
    },
    getMealsByType (mealType) {
      return this.meals.filter(meal => meal.type === mealType);
    },
    getMealTypeIndexByName (mealType) {
      const index = this.mealTypes.indexOf(this.getFilteredMealTypes[mealType]);
      return index;
    },
    getMealPage (mealType) {
      const filteredTypes = this.getFilteredMealTypes;
      if (this.getMealsByType(mealType).length > 5) {
        return 0;
      }
      const mealIndex = filteredTypes.indexOf(mealType);
      if (mealIndex === 0) {
        return 0;
      }
      if (this.getMealPage(filteredTypes[mealIndex - 1]) === 0 && this.getMealsByType(filteredTypes[mealIndex - 1]).length <= 5) {
        return 1;
      }
      return 0;
    }
  }
};
</script>

<style scoped>

.right {
  margin-left: 80%;

}

img {
  width: 170px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/FreeModePlan.vue